import makeStyles from '@mui/styles/makeStyles';
import Box from '@mui/material/Box';
import TopBar from 'components/layout/TopBar';
import Footer from '../common/Footer';
import React from 'react';
import useLanguage from 'state/hooks/use-language';

const MainContainer: React.FunctionComponent<React.PropsWithChildren> = ({ children }) => {
  const [, { setLanguage }] = useLanguage();
  const { background } = useStyles();

  const handleLanguageChange = (language: string) => setLanguage(language);

  const childrenWithProps = React.Children.map(children, (child) => {
    if (React.isValidElement(child)) {
      return React.cloneElement(child, { handleLanguageChange });
    }
    return child;
  });

  return (
    <>
      <Box bgcolor={'#F4F4F4'}>
        <Box
          className={background}
          style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}
        >
          <TopBar />
          {childrenWithProps}
          <Footer />
        </Box>
      </Box>
    </>
  );
};

const useStyles = makeStyles(() => {
  return {
    background: {
      width: '100%',
      height: '100%',
      margin: 'auto',
    },
  };
});

export default MainContainer;
